import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api'

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
})

// Add request interceptor to include auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export const attendanceService = {
  /**
   * Save manual attendance entry (single)
   */
  async saveManualAttendance(data) {
    try {
      const response = await apiClient.post('/auth/attendance/manual-attendance-store', data)
      return response.data
    } catch (error) {
      console.error('Error saving manual attendance:', error)
      throw error
    }
  },

  /**
   * Save multiple manual attendance entries (bulk)
   */
  async saveBulkManualAttendance(dataArray) {
    try {
      const response = await apiClient.post('/auth/attendance/manual-attendance-store', dataArray)
      return response.data
    } catch (error) {
      console.error('Error saving bulk manual attendance:', error)
      throw error
    }
  },

  /**
   * Fetch attendance summary report
   * @param {Object} params - { from_date, to_date, employee_id }
   */
  async getAttendanceSummary(params) {
    try {
      const response = await apiClient.get('/auth/attendance/attendance-summary-report', {
        params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching attendance summary report:', error)
      throw error
    }
  },

  /**
   * Fetch employee daily attendance sheet
   * @param {Object} params - { from_date, to_date, employee_id }
   */
  async getEmployeeDailyAttendanceSheet(params) {
    try {
      const response = await apiClient.get('/auth/attendance/employee-wise-monthly-report', {
        params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching employee daily attendance sheet:', error)
      throw error
    }
  },

  /**
   * Fetch overtime (OT) report
   * @param {Object} params - { from_date, to_date, employee_id }
   */
  async getOvertimeReport(params) {
    try {
      const response = await apiClient.get('/auth/attendance/overtime-report', {
        params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching overtime report:', error)
      throw error
    }
  },

  /**
   * Fetch late & early leave report
   * @param {Object} params - { from_date, to_date, employee_id }
   */
  async getLateEarlyReport(params) {
    try {
      const response = await apiClient.get('/auth/attendance/late-early-report', {
        params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching late & early report:', error)
      throw error
    }
  },

  /**
   * Fetch absent report
   * @param {Object} params - { from_date, to_date, employee_id }
   */
  async getAbsentReport(params) {
    try {
      const response = await apiClient.get('/auth/attendance/absent-report', {
        params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching absent report:', error)
      throw error
    }
  },

  // Expose apiClient for direct use
  apiClient
}

export default attendanceService

